var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_48301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4419 0.385742H0.878906V19.9637H34.4419V0.385742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_48301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4419 0.385742H0.878906V19.9637H34.4419V0.385742Z",
    fill: "#C40028"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_48301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4419 0.385742H0.878906V19.9637H34.4419V0.385742Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_48301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4419 0.385742H0.878906V10.1728H34.4419V0.385742Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_48301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4419 0.385742H0.878906V19.9637H34.4419V0.385742Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_48301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 0.385742V19.9637L15.5629 10.1728L0.878906 0.385742Z",
    fill: "#29457C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechRepublic);
export default __webpack_public_path__ + "static/media/CZECH_REPUBLIC.6d84cf053765f3a10a57ab1338e8c1e4.svg";
export { ForwardRef as ReactComponent };